type StoreClientProjection = {
  client_name?: string;
};

export function getStoreClientLabel(store: StoreClientProjection) {
  return store.client_name?.trim() || "Cliente desconhecido";
}

export function getValidStoreOffset(
  total: number,
  offset: number,
  pageSize: number,
) {
  if (total <= 0) return 0;
  return Math.min(offset, Math.floor((total - 1) / pageSize) * pageSize);
}
